import { render, staticRenderFns } from "./stopChat.vue?vue&type=template&id=289e24ae&"
import script from "./stopChat.vue?vue&type=script&lang=js&"
export * from "./stopChat.vue?vue&type=script&lang=js&"
import style0 from "./stopChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
